import FetchService from '../utils/request';
import Const from '../utils/const'
import jsMd5 from 'js-md5'

class UserService {
  /**
   * Creates an instance of UserService.
   * @memberOf UserService
   */
  constructor() {
    this.module = 'user';
    this.fetchService = new FetchService({});
  }

  login(user) {
    return this.fetchService.post(`/action/login`, user).then(response => {
      return response;
    });
  }

  logout() {
    return this.fetchService.post(`/action/logout`).then(response => {
      return response;
    });
  }

  check(prodCode, ssoTicket) {
    let param = '';
    if (prodCode) {
      param = "prodCode=" + prodCode;
    }
    if (ssoTicket) {
      param += (param !== '' ? '&' : '') + 'ticket=' + ssoTicket;
    }
    const _url = `/action/check` + (param !== '' ? `?` : ``) + param;
    return this.fetchService.post(_url).then(response => {
      return response;
    });
  }

  wxLogin(redirectUrl) {
    const url = `/action/wxLogin?redirectUrl=${redirectUrl}&sysCode=` + Const.wxSysCode;
    return this.fetchService.post(url).then(response => {
      return response;
    });
  }

  userApply(info){
    let time = new Date().getTime();
    let hash = jsMd5.create();
    hash.update("e7PzRm5pUr0K"+time);
    let signature = hash.hex();
    return this.fetchService.post(`/repo/kf-customer/customer-request`, info, {"signature":signature,"timestamp":time}).then(response => {
      return response;
    });
  }
}

export default new UserService();
